import { API } from '../config';
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { InputOTP, InputOTPGroup, InputOTPSlot } from './ui/input-otp';
import { Button } from './ui/button';
import { Lock } from 'lucide-react';


export function AppLockScreen({ onUnlock }) {
  const { getAuthHeaders, logout } = useAuth();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (pin.length !== 4) return;
    setLoading(true); setError('');
    try { await axios.post(`${API}/security/app-lock/verify`, { pin }, { headers: getAuthHeaders() }); onUnlock(); }
    catch (err) { setError(err.response?.data?.detail || 'Geçersiz PIN'); setPin(''); }
    finally { setLoading(false); }
  };

  React.useEffect(() => { if (pin.length === 4) handleVerify(); }, [pin]); // eslint-disable-line

  return (
    <div className="min-h-dvh bg-background flex items-center justify-center px-4" data-testid="app-lock-screen">
      <div className="w-full max-w-sm text-center space-y-6">
        <div className="flex justify-center"><div className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center"><Lock className="w-8 h-8 text-muted-foreground" /></div></div>
        <div><h1 className="text-lg font-semibold font-display">Uygulama Kilitli</h1><p className="text-sm text-muted-foreground mt-1">Kilidini açmak için PIN'inizi girin</p></div>
        <div className="flex justify-center">
          <InputOTP maxLength={4} value={pin} onChange={setPin} data-testid="app-lock-pin-input">
            <InputOTPGroup><InputOTPSlot index={0} /><InputOTPSlot index={1} /><InputOTPSlot index={2} /><InputOTPSlot index={3} /></InputOTPGroup>
          </InputOTP>
        </div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <Button onClick={handleVerify} disabled={pin.length !== 4 || loading} className="rounded-xl">{loading ? 'Doğrulanıyor...' : 'Kilidi Aç'}</Button>
        <button onClick={logout} className="text-xs text-muted-foreground hover:text-foreground transition-colors block mx-auto">Bunun yerine çıkış yap</button>
      </div>
    </div>
  );
}
